/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Checkbox, Grid, FormControlLabel } from '@mui/material';

const MapsAdvancedModalStepOne = ({
  listComponentsAdvanced,
  setListComponentsAdvanced,
  userControlSetting,
  settingsAdvanced,
  setSettingsAdvanced,
  defaultComponent,
  setDefaultComponent
}) => {
  const numColumns = 2;

  const handleCheckboxChange = key => {
    let updatedOrder = [...settingsAdvanced.orderOfComponents];
    setListComponentsAdvanced(prevListComponents => {
      const newListComponents = {
        ...prevListComponents,
        [key]: {
          ...prevListComponents[key],
          show: !prevListComponents[key].show
        }
      };

      Object.keys(newListComponents).forEach(item => {
        if (newListComponents[item].show === true && !updatedOrder.includes(item)) {
          updatedOrder.push(item);
        }
      });
      updatedOrder = updatedOrder.filter(item => newListComponents[item].show !== false);
      setSettingsAdvanced({ ...settingsAdvanced, orderOfComponents: updatedOrder });

      if (isEmpty(defaultComponent) || !newListComponents[defaultComponent].show) {
        const firstActiveComponent = Object.keys(newListComponents).find(
          item => newListComponents[item]?.show
        );
        setDefaultComponent(firstActiveComponent || '');
      }

      return newListComponents;
    });
  };

  const sortedComponents = [...userControlSetting.advancedComponents].sort((a, b) => {
    const nameA = listComponentsAdvanced[a]?.name || '';
    const nameB = listComponentsAdvanced[b]?.name || '';
    return nameA.localeCompare(nameB);
  });

  return (
    <div style={{ maxHeight: '100%' }}>
      <Grid container direction="row" wrap="nowrap" spacing={2}>
        {Array.from({ length: numColumns }).map((__, colIndex) => (
          <Grid item xs={6} key={`column-${colIndex}`}>
            <Grid container direction="column">
              {sortedComponents
                .filter((_, index) => index % numColumns === colIndex)
                .map(key => (
                  <Grid item key={key}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={listComponentsAdvanced[key]?.show || false}
                          disabled={!listComponentsAdvanced[key]}
                          sx={{
                            color: '#2A3F90',
                            '&.Mui-checked': {
                              color: '#2A3F90'
                            }
                          }}
                          onChange={() => handleCheckboxChange(key)}
                        />
                      }
                      label={listComponentsAdvanced[key]?.name || 'Component not found'}
                    />
                  </Grid>
                ))}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

MapsAdvancedModalStepOne.defaultProps = {};
MapsAdvancedModalStepOne.propTypes = {
  defaultComponent: PropTypes.string.isRequired,
  listComponentsAdvanced: PropTypes.object.isRequired,
  setDefaultComponent: PropTypes.func.isRequired,
  setListComponentsAdvanced: PropTypes.func.isRequired,
  setSettingsAdvanced: PropTypes.func.isRequired,
  settingsAdvanced: PropTypes.object.isRequired,
  userControlSetting: PropTypes.object.isRequired
};

export default MapsAdvancedModalStepOne;
